import { createRouter, createWebHistory } from 'vue-router'
import { usePreferenceStore } from '../stores/preference.js'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: () => import('../views/HomeView.vue'), alias: ['/en', '/ko', '/vi'], meta: { title: 'OYOUNG BT' } },
    { path: '/about', name: 'about', component: () => import('../views/AboutView.vue'), meta: { title: 'About Us | OYOUNG BT' } },
    { path: '/solution', name: 'solution', component: () => import('../views/SolutionView.vue'), meta: { title: 'AI Solutions | OYOUNG BT' } },
    // /health 는 리뉴얼에서 /solution 으로 승격됨 — 해시(#aps/#ags 등) 보존하며 리다이렉트
    { path: '/health', redirect: (to) => ({ path: '/solution', hash: to.hash }) },
    { path: '/cosmetic', name: 'cosmetic', component: () => import('../views/CosmeticView.vue'), meta: { title: 'Cosmetic B2B | OYOUNG BT' } },
    { path: '/brands', name: 'brands', component: () => import('../views/PartnerBrandsView.vue'), meta: { title: 'Partner Brands | OYOUNG BT' } },
    { path: '/contact', name: 'contact', component: () => import('../views/ContactView.vue'), meta: { title: 'Contact Us | OYOUNG BT' } },
    { path: '/product', name: 'product', component: () => import('../views/ProductView.vue'), meta: { title: 'OYOUNG BT' } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // /solution 의 해시(#insurance/#banking=탭, #aps/#ags/#hc-intro=섹션)는 SolutionView 가 처리 — 항상 최상단
    if (to.name === 'solution') {
      return { top: 0 }
    }
    if (to.hash) {
      return { el: `a[name=${to.hash.slice(1)}]`, top: 250 }
    }
    setTimeout(() => window.scrollTo(0, 0), 300)
    return { top: 0 }
  },
})

// 라우트별 <title> + <html lang> (renew app.js render() 재현: document.title=route.title, documentElement.lang)
router.afterEach((to) => {
  document.title = to.meta?.title || 'OYOUNG BT'
  try {
    document.documentElement.lang = usePreferenceStore().lang
  } catch (e) {
    /* Pinia 미준비 시 무시 (PageHeader.setLang 이 이후 갱신) */
  }
})

export default router
